module.exports = {
    CURRENT_CASH_TAB: 'currentCashTab',
    CASH_ACCOUNT_PENDING: 'cashAccountPending',
    WALLET_ACCOUNT_ID: 'walletAccountId'
};